var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "formpart",
    },
    [
      _vm.with_semester_selector
        ? _c("label", [
            _vm._v(
              "\n        " + _vm._s(_vm.$gettext("Semester")) + "\n        "
            ),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.semester_id,
                    expression: "semester_id",
                  },
                ],
                attrs: {
                  name: "".concat(_vm.name, "_semester_id"),
                },
                on: {
                  change: function change($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.semester_id = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.available_semesters, function (semester) {
                return _c(
                  "option",
                  {
                    key: semester.id,
                    domProps: {
                      value: semester.id,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(semester.name) +
                        "\n            "
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "default mycourses",
        },
        [
          _c("caption", [_vm._v(_vm._s(_vm.semesterName))]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th"),
              _vm._v(" "),
              _c("th"),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Nummer")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Name")))]),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "actions",
                },
                [_vm._v(_vm._s(_vm.$gettext("Auswahl")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.courses, function (course) {
                return _c(
                  "tr",
                  {
                    key: course.id,
                  },
                  [
                    _c("td", {
                      class: "gruppe".concat(course.group),
                    }),
                    _vm._v(" "),
                    _c("td", [
                      _c("img", {
                        staticClass: "my-courses-avatar course-avatar-small",
                        attrs: {
                          src: course.avatar_url,
                          alt: "",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(course.number))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(course.name))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "actions",
                      },
                      [
                        _c("input", {
                          attrs: {
                            type: "hidden",
                            name: ""
                              .concat(_vm.name, "_course_ids[")
                              .concat(course.id, "]"),
                            value: "0",
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            type: "checkbox",
                            name: ""
                              .concat(_vm.name, "_course_ids[")
                              .concat(course.id, "]"),
                            value: "1",
                            title: _vm.$gettextInterpolate(
                              _vm.$gettext("%{course} auswählen"),
                              {
                                course: course.name,
                              }
                            ),
                          },
                          domProps: {
                            checked: _vm.selected_course_id_list.includes(
                              course.id
                            ),
                          },
                        }),
                      ]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.loadedSemesters.includes(_vm.semester_id) &&
              _vm.courses.length === 0
                ? _c("tr", [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan: "5",
                        },
                      },
                      [
                        _c("studip-message-box", [
                          _vm._v(
                            _vm._s(
                              _vm.$gettext(
                                "Im gewählten Semester stehen keine Veranstaltungen zur Auswahl zur Verfügung."
                              )
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "7px",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "25px",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "70px",
        },
      }),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }